export default __webpack_public_path__ + "static/media/blog-inactive.6f1d2141.svg";